export const BUSINESS_NAME = "Northern Virginia Foodies";
export const BASE_URL = "nova-foodies.com";
export const PHONE_NUMBER = "";
export const ADDRESS1 = "";
export const ADDRESS2 = "";
export const CITY = "";
export const STATE = "";
export const ZIP = "";
export const FULL_ADDRESS = ADDRESS1 + " " + ADDRESS2 + " " + CITY + ", " + STATE + " " + ZIP;
export const EMAIL = "";
export const GOOGLE_MAPS_URL = "https://goo.gl/maps/XXXXXXXXXXXXXXXXXXXXXXXX";
export const FACEBOOK_URL = "https://www.facebook.com/groups/1489102121372188";
export const INSTAGRAM_URL = "https://www.instagram.com/northernvirginiafoodies/";
